import { EnvironmentObject } from '@rapid-recovery-agency-inc/insightt-shared';
import { setupEnv, SsoEnvironment, withSsoEnvironment } from '../modules/environment/environment-utils';

/**
 * ENVIRONMENT object
 * @experimental
 * @returns an object containing ENV variables from .env and remote api, plus the build-time SSO
 * settings (`SsoEnvironment`)
 */
export const ENVIRONMENT: EnvironmentObject & SsoEnvironment = withSsoEnvironment(setupEnv());
